import {ApplicationEnvironmentTypeEnum} from "../../env.configs.interface";

export const APP_ROOT_ELEMENT_ID = 'search-mask-root';

export interface IApplicationService {
    readonly isActive: boolean;
    readonly isInMobileView: boolean;
    sendEnvironmentTypeEvent(environmentType: ApplicationEnvironmentTypeEnum): void;
}
